import { render } from "./transferencia.vue?vue&type=template&id=3f3dc12e&scoped=true"
import script from "./transferencia.vue?vue&type=script&lang=js"
export * from "./transferencia.vue?vue&type=script&lang=js"

import "./transferencia.vue?vue&type=style&index=0&id=3f3dc12e&lang=scss&scoped=true"
import "./transferencia.vue?vue&type=style&index=1&id=3f3dc12e&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f3dc12e"]])

export default __exports__